export const SUBSCRIPTION_TRIAL = 0;
export const SUBSCRIPTION_CREATOR = 1;
export const SUBSCRIPTION_BUSINESS = 2;
export const SUBSCRIPTION_ENTERPRISE = 3;
export const SUBSCRIPTION_CREATOR_ANNUAL = 4;
export const SUBSCRIPTION_BUSINESS_ANNUAL = 5;

export const isCreatorSubscription = (tier: number | undefined) =>
  tier === SUBSCRIPTION_CREATOR || tier === SUBSCRIPTION_CREATOR_ANNUAL;
export const isBusinessSubscription = (tier: number | undefined) =>
  tier === SUBSCRIPTION_BUSINESS || tier === SUBSCRIPTION_BUSINESS_ANNUAL;
export const isAnnualSubscription = (tier: number | undefined) =>
  tier === SUBSCRIPTION_CREATOR_ANNUAL || tier === SUBSCRIPTION_BUSINESS_ANNUAL;

export const chooseCreatorSubscription = (
  currentSubscription: number | undefined,
) =>
  currentSubscription === SUBSCRIPTION_TRIAL ||
  currentSubscription === SUBSCRIPTION_ENTERPRISE ||
  currentSubscription === SUBSCRIPTION_CREATOR ||
  currentSubscription === SUBSCRIPTION_BUSINESS
    ? SUBSCRIPTION_CREATOR
    : SUBSCRIPTION_CREATOR_ANNUAL;
export const chooseBusinessSubscription = (
  currentSubscription: number | undefined,
) =>
  currentSubscription === SUBSCRIPTION_TRIAL ||
  currentSubscription === SUBSCRIPTION_ENTERPRISE ||
  currentSubscription === SUBSCRIPTION_CREATOR ||
  currentSubscription === SUBSCRIPTION_BUSINESS
    ? SUBSCRIPTION_BUSINESS
    : SUBSCRIPTION_BUSINESS_ANNUAL;

export const chooseAnnualSubscription = (idToFix: number | undefined) => {
  return isCreatorSubscription(idToFix)
    ? SUBSCRIPTION_CREATOR_ANNUAL
    : isBusinessSubscription(idToFix)
    ? SUBSCRIPTION_BUSINESS_ANNUAL
    : idToFix;
};
export const chooseMonthlySubscription = (idToFix: number | undefined) => {
  return isCreatorSubscription(idToFix)
    ? SUBSCRIPTION_CREATOR
    : isBusinessSubscription(idToFix)
    ? SUBSCRIPTION_BUSINESS
    : idToFix;
};

export const fixSubscriptionId = (
  idToFix: number | undefined,
  currentSubscription: number,
) => {
  if (isCreatorSubscription(idToFix))
    return chooseCreatorSubscription(currentSubscription);
  if (isBusinessSubscription(idToFix))
    return chooseBusinessSubscription(currentSubscription);
  return idToFix;
};
export const fixSubscriptionIdForAnnual = (
  idToFix: number | undefined,
  isAnnual: boolean,
) => {
  if (isCreatorSubscription(idToFix))
    return isAnnual ? SUBSCRIPTION_CREATOR_ANNUAL : SUBSCRIPTION_CREATOR;
  if (isBusinessSubscription(idToFix))
    return isAnnual ? SUBSCRIPTION_BUSINESS_ANNUAL : SUBSCRIPTION_BUSINESS;
  return idToFix;
};
export const isSameSubscription = (
  id1: number,
  id2: number,
  ignoreAnnualOrMonthly: boolean,
) => {
  if (!ignoreAnnualOrMonthly) {
    return id1 === id2;
  }
  if (isCreatorSubscription(id1) && isCreatorSubscription(id2)) {
    return true;
  }
  if (isBusinessSubscription(id1) && isBusinessSubscription(id2)) {
    return true;
  }
  return id1 === id2;
};
